var _style, _metadata, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCt7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4F0C3;stroke:#231F20;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 44,
    width: 44,
    x: 0,
    y: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 22,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.3,11.6h10.4c1,0,1.7,0.2,2.2,0.5s0.7,0.8,0.7,1.5c0,0.4-0.3,1-0.8,1.7s-1.1,1.5-1.8,2.4 c-0.7,0.9-1.4,2-2.1,3.2s-1.4,2.9-2,4.7c-0.2,0.8-0.4,1.5-0.5,2s-0.2,1.2-0.3,2.1s-0.2,1.5-0.3,2c-0.2,1.1-0.5,1.8-0.9,2.2 c-0.4,0.4-0.9,0.6-1.6,0.6c-0.6,0-1.1-0.2-1.5-0.7c-0.4-0.4-0.6-1.1-0.6-2c0-0.7,0.1-1.6,0.4-2.7s0.7-2.5,1.4-4.1 c0.6-1.6,1.4-3.2,2.4-4.9c1-1.7,2.1-3.4,3.4-5h-8.4c-0.9,0-1.5-0.2-1.9-0.5s-0.6-0.8-0.6-1.5s0.2-1.2,0.7-1.4 C15.9,11.7,16.5,11.6,17.3,11.6L17.3,11.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt7);
export default __webpack_public_path__ + "static/media/CT7.80b5f40e105373a00c1e3556b77dba2b.svg";
export { ForwardRef as ReactComponent };